import { useLocale, useTranslations } from 'next-intl';
import React from 'react';
// import Image from 'next/image';
// import { Input } from '@/components/ui/input';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

const Banner = ({
  title,
  subTitlle,
  // onSearch,
  showError,
  onClickConsultCustomerService,
}: {
  title?: string;
  subTitlle?: string;
  onSearch?: (value: string) => void;
  showError?: {
    show?: boolean;
    message?: string;
  };
  onClickConsultCustomerService?: () => void; // 点击联系客服
}) => {
  const t = useTranslations();
  const currentLocale = useLocale();
  // PC
  // const [showSearchBox, setShowSearchBox] = useState<boolean>(false);
  // const [searchInputValue, setSearchInputValue] = useState<string>('');
  // h5
  // const [showSearchIcon, setShowSearchIcon] = useState<boolean>(true);
  // const [h5SearchValue, setH5SearchValue] = useState<string>('');

  return (
    <div
      // className="box-border flex h-[220px] w-full flex-row items-center justify-between bg-[#2A2B45] pl-[8.164vw] pr-[9.88vw] max-md:h-[318px] max-md:flex-col max-md:items-center max-md:justify-start max-md:p-0 max-md:pt-10"
      className="box-border flex h-[220px] w-full flex-row items-center justify-between bg-[#2A2B45] pl-[8.164vw] pr-[9.88vw] max-md:h-[266px] max-md:flex-col max-md:items-center max-md:justify-start max-md:p-0 max-md:pt-10"
      style={{
        backgroundImage: 'url(/images/common/planeBg.png)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div className="max-md:mb-[30px] max-md:w-[92%]">
        <h1 className="mb-[22px] text-[38px] font-medium leading-[38px] text-white max-md:mb-[11px] max-md:text-xl max-md:leading-5">
          {title}
        </h1>
        <h1 className="text-[36px] font-bold uppercase leading-9 text-white opacity-20 max-md:text-lg max-md:leading-[18px]">
          {subTitlle}
        </h1>
      </div>
      <div className="max-md:hidden">
        <div className="flex flex-row items-center justify-end">
          {/* {showSearchBox ? (
            <div className="flex h-[60px] w-[570px] flex-row items-center justify-between bg-white">
              <Input
                id="bannerSearchInput"
                value={searchInputValue}
                className="h-full flex-1 transform border-none text-lg leading-[18px] text-[#111111] transition-transform duration-500"
                placeholder={t('Bannder.inputPlaceholder')}
                onChange={(e) => setSearchInputValue(e.target.value)}
              />
              <div className="ml-5 flex size-[60px] cursor-pointer flex-row items-center justify-center bg-white">
                <Image
                  src={'/images/common/search.png'}
                  width={33}
                  height={34}
                  className="h-auto w-[33px]"
                  alt="search"
                  onClick={() => {
                    console.log(searchInputValue);
                    if (onSearch) onSearch(searchInputValue);
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="flex size-[60px] cursor-pointer flex-row items-center justify-center bg-white">
              <Image
                src={'/images/common/search.png'}
                width={33}
                height={34}
                className="h-auto w-[33px]"
                alt="search"
                onClick={() => setShowSearchBox(true)}
              />
            </div>
          )} */}

          <div
            className={`ml-4 flex h-[60px] w-[140px] cursor-pointer flex-row items-center justify-center bg-[#FFB12A] text-center ${currentLocale === 'zh' ? 'text-xl leading-5' : 'w-[160px] px-2 text-base leading-4'} font-medium text-[#2A2B45]`}
            onClick={() => {
              if (onClickConsultCustomerService) {
                onClickConsultCustomerService();
              }
            }}
          >
            {t('Immigration.consultCustomerService')}
          </div>
        </div>
        {showError?.show && (
          <Alert variant="destructive" className="mt-3 border-red-700 text-red-700">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>{t('Bannder.error')}</AlertTitle>
            <AlertDescription>{showError?.message}</AlertDescription>
          </Alert>
        )}
      </div>
      {/* <div className="box-border flex h-[42px] w-[92%] flex-row items-center justify-between rounded-full bg-white pl-[17px] pr-1 md:hidden">
        <div className="relative flex h-9 flex-1 flex-row items-center justify-start">
          {showSearchIcon && (
            <Image src={`/images/home/search.png`} width={35} height={35} className="size-[18px]" alt="search" />
          )}
          <Input
            value={h5SearchValue}
            className="absolute left-0 top-0 h-full w-full flex-1 border-none pl-0 text-[#111111]"
            onFocus={() => setShowSearchIcon(false)}
            onChange={(e) => {
              const value = e.target.value;
              if (!value) {
                setShowSearchIcon(true);
              } else {
                setShowSearchIcon(false);
              }
              setH5SearchValue(e.target.value);
            }}
          />
        </div>
        <div
          className="flex h-[35px] w-[60px] flex-row items-center justify-center rounded-[35px] bg-[#FFAF3A] text-xs text-[#333333]"
          onClick={() => {
            // todo
            console.log(h5SearchValue);
            if (onSearch) onSearch(h5SearchValue);
          }}
        >
          {t('Home.search')}
        </div>
      </div> */}
    </div>
  );
};

export default Banner;
